import React, { useState, useEffect, useRef } from 'react';
import { Card, Col, Row, Input, Select, Pagination, Empty } from 'antd';
import './TableCard.scss';
import { Link } from 'react-router-dom';
import common from '../../common';
import { AiOutlineLike } from 'react-icons/ai';

const { Option } = Select;

function TableCard({ data = [], pageSize = 10, categoryOptions = ['전체', '제목', '내용'] }) {

    const { useAlert, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();

    // 검색 카테고리 상태
    const [searchCategory, setSearchCategory] = useState('전체');
    // 검색 텍스트 상태
    const [searchText, setSearchText] = useState('');
    // 필터된 데이터 상태
    const [filteredData, setFilteredData] = useState([]);
    // 현재 페이지 상태
    const [currentPage, setCurrentPage] = useState(1);
    // 타이머 참조를 저장할 useRef 훅
    const searchTimeout = useRef(null);

    // 데이터 변경 시 로딩 시작
    useEffect(() => {
        pLoadingOn(); // 로딩 시작
        setFilteredData(data);
        setCurrentPage(1); // 데이터 변경 시 페이지를 초기화
    }, [data]);

    // 검색 카테고리 또는 텍스트가 변경될 때 필터링 작업 수행
    useEffect(() => {
        if (filteredData.length > 0 || searchText === '') {
            pLoadingOff(); // 필터링 작업이 완료되면 로딩 종료
        }
    }, [filteredData]);

    // 검색 카테고리 변경 핸들러
    const handleSearchCategoryChange = (value) => {
        setSearchCategory(value);
        handleSearch(searchText, value);
    };

    // 검색 텍스트 변경 핸들러
    const handleSearchTextChange = (e) => {
        const value = e.target.value;
        setSearchText(value);

        if (searchTimeout.current) {
            clearTimeout(searchTimeout.current);
        }
        searchTimeout.current = setTimeout(() => {
            handleSearch(value, searchCategory);
        }, 500); // 0.5초 딜레이
    };

    // 검색 기능 핸들러
    const handleSearch = (text, category) => {
        if (text === '') {
            setFilteredData(data);
            return;
        }

        const filtered = data.filter(item => {
            if (category === '전체') {
                // 아이템 객체의 모든 필드를 확인합니다.
                return Object.values(item).some(value =>
                    typeof value === 'string' && value.includes(text)
                );
            } else {
                // 특정 카테고리만 확인합니다.
                const value = item[category];
                return value && typeof value === 'string' && value.includes(text);
            }
        });

        
        setFilteredData(filtered);
    };

    // 페이지 변경 핸들러
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <>
            <LoadingComponent />
            <div className='p_tableCard_box'>
                {/* 검색 기능을 위한 컨테이너 */}
                <div className="search_container_wrap">
                    <div className="search_container">
                        <Select className='p_select p_table_select' value={searchCategory} onChange={handleSearchCategoryChange}>
                            {categoryOptions.map(option => (
                                <Option key={option.value} value={option.value} className="p_table_option">{option.label}</Option>
                            ))}
                        </Select>
                        <Input className='p_input p_table_search_input' placeholder="검색어를 입력해주세요." value={searchText} onChange={handleSearchTextChange} />
                        <button className='p_search_icon'></button>
                    </div>
                </div>
                <div className="p_tableCard_main_box">
                    {filteredData.length === 0 ? (
                        // 데이터가 없을 때 표시할 Empty 컴포넌트
                        <Empty description="내역이 없습니다" />
                    ) : (
                        <>
                            {/* 그리드 레이아웃을 만드는 Row 컴포넌트 */}
                            <Row>
                                {filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize).map((item) => (
                                    // 각 카드가 그리드의 한 열을 차지하도록 하는 Col 컴포넌트
                                    <Col span={8} key={item.idx}>
                                        <Link 
                                            className='card_detail_btn'
                                            to={`/noticedetail?id=${item.idx}&type=document`}
                                            state={item}
                                        >
                                            <Card
                                                cover={<div style={{
                                                    backgroundImage: `url(${item.thumbnail || '/img/logo2.png'})`,
                                                }}
                                                className='thumbnail_img' />}
                                            >
                                                <div className="card_wrap">
                                                    <div className="card_box">
                                                        <div className="card_top_box">
                                                            <div className='card_title'>
                                                                {item.headCate ? <b>[{item.headCate}]</b> : null}
                                                                {item.title}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card_box">
                                                        <div className="member_box">
                                                            <span>{item.member}</span>
                                                        </div>

                                                        <div className="card_views_box">
                                                            <div className='card_views'></div>
                                                            <span className='card_count' key="views">{item.view}</span>
                                                        </div>

                                                        <div className="like_count_box">
                                                            <div className='card_like_count'><AiOutlineLike /></div>
                                                            <span className='card_count' key="views">{item.likeCount}</span>
                                                        </div>
                                                        
                                                        
                                                    </div>
                                                </div>
                                            </Card>
                                        </Link>
                                    </Col>
                                ))}
                            </Row>
                            {/* 페이지네이션 컴포넌트 */}
                            <Pagination
                                current={currentPage}
                                total={filteredData.length}
                                pageSize={pageSize}
                                onChange={handlePageChange}
                            />
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default TableCard;
